export default "__VITE_ASSET__2a70b099__"